import React from 'react';
import Header from '../components/Header';
import Services from '../components/Services';
import Footer from '../components/Footer';
import PageHeader from '../components/PageHeader';

const ServicesPage = () => {
  return (
    <div className="App">
      <Header />
      <main>
        <PageHeader
          title="Serviços de TI"
          subtitle="Soluções integradas para apoiar, proteger e modernizar a operação da sua empresa."
          breadcrumb="Serviços"
        />
        <Services />
      </main>
      <Footer />
    </div>
  );
};

export default ServicesPage;

